<template>
    <lq-el-form
        @submited-success="submitted"
        name="forget_password"
        auto-complete="off"
        :rules="rules"
        action="forget-password"
    >
        <el-card shadow="always" :style="{overflow: 'initial'}">
            <lq-el-phone-or-text
                id="email"
                fetch-country
                :preferred-countries="['IN', 'SG']"
                placeholder="Email/Mobile No."
            />

            <el-row align="middle" justify="end">
                <el-col :span="12">
                    <lq-el-submit label="Submit" />
                </el-col>
                <el-col :span="12" align="right">
                    <div :style="{paddingTop: '5px'}">
                        <router-link :to="{ path: '/'}" class="link">Login</router-link>
                    </div>
                </el-col>
            </el-row>
        </el-card>
    </lq-el-form>
</template>
<script>
export default {
    name: 'login-form',
    data: function() {
        return {
            rules: {
                email: {
                    // email: true,
                    presence: {
                        allowEmpty: false,
                        message: 'Email/Mobile no. field is required'
                    },
                    format: {
                        pattern: /(^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))|(^\+?([0-9]){1,4}?(\-)?([0-9 \s]){6,12}))/,
                        message: 'Please enter a valid email or mobile.'
                    }
                }
            }
        };
    },
    methods: {
        submitted: function(resposne) {
            this.$router.push('/reset-password');
        }
    }
};
</script>

